import { graphql } from "gql";

const HAPPYCO_RESIDENTS_QUERY = graphql(`
  query HappycoResidents($propertyId: String!, $unitId: String) {
    happycoResidents(propertyId: $propertyId, unitId: $unitId) {
      ...HappycoResident
    }
  }
`);

export default HAPPYCO_RESIDENTS_QUERY;
